import {
  createReducer,
  createNamespacer
} from '../../commons/js/utils/reducer';

const initialState = {
  list: {
    isLoading: true,
    projects: [],
    ownersList: [],
    foremenList: [],
    showEditProject: false,
    showAddProject: false,
    error: '',
    currentPage: 1,
    pageCount: 0,
    search: '',
    isScheduler: false,
    clientsList: [],
    selectedClient: { value: null, label: '' },
  }
};

const listProjects = createNamespacer('PROJECTS_LIST');

export const listReducer = createReducer(initialState.list, {
  SET_SHOW_EDIT_PROJECT: (state, action) => {
    return {
      ...state,
      showEditProject: action.payload.value
    };
  },
  SET_SHOW_ADD_PROJECT: (state, action) => {
    return {
      ...state,
      showAddProject: action.payload.value
    };
  },
  [listProjects('SET_SEARCH_PROJECTS')]: (state, action) => {
    return {
      ...state,
      search: action.payload.value
    };
  },
  [listProjects('SET_IS_SCHEDULER')]: (state, action) => {
    return {
      ...state,
      isScheduler: action.payload.value
    };
  },
  [listProjects('SET_CLEAR_SEARCH')]: (state, action) => {
    return {
      ...state,
      search: initialState.search
    };
  },
  [listProjects('SET_OWNERS_LIST')]: (state, action) => {
    return {
      ...state,
      ownersList: action.payload.value
    };
  },
  [listProjects('SET_FOREMEN_LIST')]: (state, action) => {
    return {
      ...state,
      foremenList: action.payload.value
    };
  },
  [listProjects('SET_CREW_FOREMEN_LIST')]: (state, action) => {
    return {
      ...state,
      crewForemenList: action.payload.value
    };
  },
  [listProjects('SET_FIELD_FOREMAN_LIST')]: (state, action) => {
    return {
      ...state,
      fieldUsersList: action.payload.value
    };
  },
  [listProjects('SET_PROJECTS')]: (state, action) => {
    return {
      ...state,
      projects: action.payload.value,
      pageCount: action.payload.pages
    };
  },
  [listProjects('SET_LOADING')]: (state, action) => {
    return {
      ...state,
      isLoading: action.payload.value
    };
  },
  [listProjects('SET_PAGE')]: (state, action) => {
    return {
      ...state,
      currentPage: action.payload.value
    };
  },
  [listProjects('SET_ERROR')]: (state, action) => {
    return {
      ...state,
      error: action.payload.value
    };
  },
  [listProjects('SET_ACTIVE_CLIENTS')]: (state, action) => {
    return {
      ...state,
      clientsList: action.payload.clients
    };
  },
  [listProjects('SET_SELECTED_CLIENT')]: (state, action) => {
    return {
      ...state,
      selectedClient: action.payload
    };
  },
});
